import { render, staticRenderFns } from "./VerifiedSelect.vue?vue&type=template&id=63d540e4"
import script from "./VerifiedSelect.vue?vue&type=script&lang=js"
export * from "./VerifiedSelect.vue?vue&type=script&lang=js"
import style0 from "./VerifiedSelect.vue?vue&type=style&index=0&id=63d540e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports